import { __assign } from 'tslib';
export var assign = __assign;